const INVOICE_PROFITABILITY_URL = "/v1/detail-report/invoice-profitability";
const STOCK_ANALYSIS_URL = "/v1/detail-report/stock-analysis";
//const STOCK_GROUP_ANALYSIS_ADD_URL = "/v1/detail-report/stock-group-analysis";
//const STOCK_CODE_1_ANALYSIS_URL = "/v1/detail-report/stock-code1-analysis";
//const STOCK_CODE_2_ANALYSIS_URL = "/v1/detail-report/stock-code2-analysis";
//const STOCK_CODE_3_ANALYSIS_URL = "/v1/detail-report/stock-code3-analysis";
//const STOCK_CODE_4_ANALYSIS_URL = "/v1/detail-report/stock-code4-analysis";
//const STOCK_CODE_5_ANALYSIS_URL = "/v1/detail-report/stock-code5-analysis";
const SALES_PERSON_STOCK_SALE_URL = "/v1/detail-report/salesperson-stock-sale";
const BEST_SALES_URL = "/v1/detail-report/best-sales";
const CURRENT_PERFORMANCE_URL = "/v1/detail-report/current-performance";
const GENERAL_DEBT_STATEMENT_URL = "/v1/detail-report/general-debt-statement";
const CHEQUE_URL = "/v1/detail-report/cheque";
const BILL_URL = "/v1/detail-report/bill";
const SAFE_URL = "/v1/detail-report/safe";
const CURRENT_GIRO_URL = "/v1/report/current-giro";
const SALES_PERSON_GIRO_URL = "/v1/report/salesperson-giro";
const COMPANY_TOTAL_INFO_URL = "/v1/report/company-total-info";
const STOCK_DETAIL_URL = "/v1/report/stock-detail";
const MONTH_GIRO_DISTRIBUTION_URL = "/v1/report/month-giro-distribution";
const GIRO_ANALYSIS_URL = "/v1/report/giro-analysis";
const SALE_URL = "/v1/report/sale";
const CURRENCY_SALE_URL = "/v1/report/currency-sale-detail";
const CURRENCY_PURCHASE_URL = "/v1/report/currency-purchase-detail"
const PURCHASE_URL = "/v1/report/purchase";
const CHEQUE_SUM_URL = "/v1/report/cheque-sum";
const BILL_SUM_URL = "/v1/report/bill-sum";
const BORROWER_CURRENT_LIST_URL = "/v1/report/borrower-current-list";
const PAYEE_CURRENT_LIST_URL = "/v1/report/payee-supplier-list";
const BEST_STOCK_LIST_URL = "/v1/report/best-stocks";
const SALESPERSON_SALE_PAYMENT_LIST_URL = "/v1/report/salesperson-sale-payment";
const EXPENSE_LIST_URL = "/v1/report/expense";
const EXPENSE_LIST_TOTAL_URL = "/v1/report/expense-sum";
const SALESPERSON_SALE_PAYMENT_DETAIL_LIST_URL = "/v1/report/salesperson-sale-payment-detail"
const TOP_10_CURRENT_LIST_URL = "/v1/report/best-current-list"
const BANKS_URL = "/v1/report/bank"
const BANK_DETAILS_URL = "/v1/report/bank-detail"
const CURRENT_AGING_SUMMARY_SUM = "/v1/detail-report/current-aging-summary-sum"
const CURRENT_VISIT = "/v1/detail-report/current-visit"
const NEW_CURRENT = "/v1/detail-report/new-current"


const REPORT_API_URL_LIST = {

    INVOICE_PROFITABILITY_URL,
    STOCK_ANALYSIS_URL,
    //STOCK_GROUP_ANALYSIS_ADD_URL,
    //STOCK_CODE_1_ANALYSIS_URL,
    //STOCK_CODE_2_ANALYSIS_URL,
    //STOCK_CODE_3_ANALYSIS_URL,
    //STOCK_CODE_4_ANALYSIS_URL,
    //STOCK_CODE_5_ANALYSIS_URL,
    SALES_PERSON_STOCK_SALE_URL,
    BEST_SALES_URL,
    CURRENT_PERFORMANCE_URL,
    GENERAL_DEBT_STATEMENT_URL,
    CHEQUE_URL,
    BILL_URL,
    SAFE_URL,
    CURRENT_GIRO_URL,
    SALES_PERSON_GIRO_URL,
    COMPANY_TOTAL_INFO_URL,
    STOCK_DETAIL_URL,
    MONTH_GIRO_DISTRIBUTION_URL,
    GIRO_ANALYSIS_URL,
    SALE_URL,
    CURRENCY_SALE_URL,
    PURCHASE_URL,
    CURRENCY_PURCHASE_URL,
    CHEQUE_SUM_URL,
    BORROWER_CURRENT_LIST_URL,
    PAYEE_CURRENT_LIST_URL,
    BEST_STOCK_LIST_URL,
    SALESPERSON_SALE_PAYMENT_LIST_URL,
    EXPENSE_LIST_URL,
    EXPENSE_LIST_TOTAL_URL,
    SALESPERSON_SALE_PAYMENT_DETAIL_LIST_URL,
    TOP_10_CURRENT_LIST_URL,
    BILL_SUM_URL,
    BANKS_URL,
    BANK_DETAILS_URL,
    CURRENT_AGING_SUMMARY_SUM,
    CURRENT_VISIT,
    NEW_CURRENT,
}

export {REPORT_API_URL_LIST};